import { render, staticRenderFns } from "./input-unit-number.vue?vue&type=template&id=22daea1a&scoped=true"
import script from "./input-unit-number.ts?vue&type=script&lang=ts&external"
export * from "./input-unit-number.ts?vue&type=script&lang=ts&external"
import style0 from "./input-unit-number.vue?vue&type=style&index=0&id=22daea1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22daea1a",
  null
  
)

export default component.exports